/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericBenefit } from './GenericBenefit';
import {
    GenericBenefitFromJSON,
    GenericBenefitFromJSONTyped,
    GenericBenefitToJSON,
    GenericBenefitToJSONTyped,
} from './GenericBenefit';

/**
 * 
 * @export
 * @interface ActiveCoverageOtherPayers
 */
export interface ActiveCoverageOtherPayers {
    /**
     * 
     */
    sections?: Array<GenericBenefit>;
}

/**
 * Check if a given object implements the ActiveCoverageOtherPayers interface.
 */
export function instanceOfActiveCoverageOtherPayers(value: object): value is ActiveCoverageOtherPayers {
    return true;
}

export function ActiveCoverageOtherPayersFromJSON(json: any): ActiveCoverageOtherPayers {
    return ActiveCoverageOtherPayersFromJSONTyped(json, false);
}

export function ActiveCoverageOtherPayersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveCoverageOtherPayers {
    if (json == null) {
        return json;
    }
    return {
        
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(GenericBenefitFromJSON)),
    };
}

export function ActiveCoverageOtherPayersToJSON(json: any): ActiveCoverageOtherPayers {
    return ActiveCoverageOtherPayersToJSONTyped(json, false);
}

export function ActiveCoverageOtherPayersToJSONTyped(value?: ActiveCoverageOtherPayers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(GenericBenefitToJSON)),
    };
}

